<template>
  <v-card flat>
    <custom-tabs v-model="tab" :tab-items="tabItems" grow>
      <template v-slot:staticItems>
        <!-- تب اول: عکس و جهت -->
        <v-tab-item class="ma-5 mt-8">
          <v-row>
            <v-col cols="12" md="12">
              <v-select
                v-model="localValue.orientation"
                :items="[
                  { text: 'افقی', value: 'horizontal' },
                  { text: 'عمودی', value: 'vertical' },
                ]"
                label="جهت کارت"
                outlined
                dense
                @change="updateValue"
              ></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <span class="mb-2 d-block font-weight-bold">تصویر روی کارت</span>
              <pic-selector
                single
                one-pic
                :field.sync="localValue.front_image"
                @change="updateValue"
                :edit-img="false"
                :edit-name="false"
              />
            </v-col>

            <v-col cols="12" md="6">
              <span class="mb-2 d-block font-weight-bold">تصویر پشت کارت</span>
              <pic-selector
                single
                one-pic
                :field.sync="localValue.back_image"
                @change="updateValue"
                :edit-img="false"
                :edit-name="false"
              />
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- تب دوم: رنگ پس‌زمینه -->
        <v-tab-item class="ma-5 mt-8">
          <v-row>
            <!-- سوییچ Transparent -->
            <v-col cols="12" class="pb-0">
              <v-switch
                v-model="localValue.transparent"
                true-value="on"
                false-value="off"
                label="پس‌زمینه کیوآرکد شفاف (Transparent) باشد"
                color="primary"
                inset
                hide-details
                class="mt-0"
                @change="updateValue"
              ></v-switch>
              <v-divider class="my-4"></v-divider>
            </v-col>

            <template v-if="localValue.transparent === 'off'">
              <v-col cols="12" class="pb-0">
                <v-switch
                  v-model="localValue.bgType"
                  true-value="gradient"
                  false-value="solid"
                  :label="
                    localValue.bgType === 'gradient'
                      ? 'حالت رنگ: گرادیان (طیف‌دار)'
                      : 'حالت رنگ: ساده'
                  "
                  color="primary"
                  inset
                  hide-details
                  class="mt-0"
                  @change="updateValue"
                ></v-switch>
                <v-divider class="my-4"></v-divider>
              </v-col>

              <!-- تنظیمات رنگ ساده -->
              <v-col cols="12" md="6" v-if="localValue.bgType === 'solid'">
                <span class="mb-2 d-block font-weight-bold">انتخاب رنگ:</span>
                <color-picker
                  v-model="localValue.solidColor"
                  size="100%"
                  @input="updateValue"
                />
              </v-col>

              <!-- تنظیمات رنگ گرادیان -->
              <template v-if="localValue.bgType === 'gradient'">
                <v-col cols="12" md="4">
                  <span class="mb-2 d-block font-weight-bold">رنگ اول:</span>
                  <color-picker
                    v-model="localValue.gradientColor1"
                    size="100%"
                    @input="updateValue"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <span class="mb-2 d-block font-weight-bold">رنگ دوم:</span>
                  <color-picker
                    v-model="localValue.gradientColor2"
                    size="100%"
                    @input="updateValue"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <span class="mb-2 d-block font-weight-bold"
                    >جهت گرادیان:</span
                  >
                  <v-select
                    v-model="localValue.gradientDirection"
                    :items="gradientDirections"
                    outlined
                    dense
                    @change="updateValue"
                  />
                </v-col>
              </template>
            </template>
          </v-row>
        </v-tab-item>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector";
import ColorPicker from "@/view/pages/qrland/components/colorPicker";

export default {
  name: "BulkImageColorPanel",
  components: {
    PicSelector,
    ColorPicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tabItems: [
        { text: "تصاویر و جهت کارت", icon: "image" },
        { text: "رنگ پس‌زمینه", icon: "brush" },
      ],
      tab: 0,
      localValue: { ...this.value },
      gradientDirections: [
        { text: "به سمت راست", value: "to right" },
        { text: "به سمت چپ", value: "to left" },
        { text: "به سمت پایین", value: "to bottom" },
        { text: "به سمت بالا", value: "to top" },
        { text: "مورب (پایین-راست)", value: "to bottom right" },
      ],
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.localValue = { ...newVal };
      },
      deep: true,
    },
  },
  methods: {
    updateValue() {
      this.$emit("input", this.localValue);
    },
  },
};
</script>

<style scoped>
.transparent {
  background-color: transparent !important;
}
</style>
